<!-- コースマスタ　一覧画面 -->
<style src="@/assets/css/admin_parts.css" type="text/css" media="all" scoped></style>
<template>
	<div class="contents" id="wirks">
		<!-- ▽  -->
		<section id="mainContent">
			<h2>コースマスタ</h2>
			<ul class="contntMenu">
				<li class="onBack" v-on:click="onBack">TOP</li>
			</ul>

			<!-- ▽  -->
			<section class="inputArea">
				<table class="listTbl">
					<caption>
					<!--クライアントプルダウン-->
						<div class="listUp">
							<b>クライアント</b>
							<select v-model="inputForm.jgcd">
								<option v-for="item in inputForm.listJgyo" v-bind:value="item.jgcd" v-bind:key="item.jgcd">
									{{item.jgnm}}
								</option>
							</select>
							<button class="onSearch" v-on:click="onSearch">検索</button>
						</div>
						<div class="btnLst">
							<button class="newBtn" v-on:click="onRegister">新規作成</button>
							<button class="confBtn" v-on:click="onUpdateNend">年度更新</button>
						</div>
					</caption>
					<thead>
						<tr>
							<th>名称</th>
							<td>年度</td>
							<td>予約登録期間</td>
							<td>公開</td>
							<td>設定項目</td>
							<td></td>
						</tr>
					</thead>
					<tbody>
						<tr v-for="list in displayLists"  v-bind:key="list.key">
							<th>{{list.ksnm}}</th>
							<td>{{list.nend}}</td>
							<td>{{list.stdy}} ～ {{list.eddy}}</td>
							<td>{{list.upokDisplay}}</td>
							<td class="menuList">
								<ul>
									<li class="onDetailWIRKM"><a v-on:click="onDetailWIRKM(list.nend,list.jgcd,list.kscd,list.key)">検査項目</a></li>
									<li class="onDetailWKSWK"><a v-on:click="onDetailWKSWK(list.nend,list.jgcd,list.kscd,list.key)">予約枠</a></li>
									<li class="onDetailWRKKS"><a v-on:click="onDetailWRKKS(list.nend,list.jgcd,list.kscd,list.key)">料金</a></li>
									<li class="onDetailOPTION"><a v-on:click="onDetailOPTION(list.nend,list.jgcd,list.kscd,list.key)">オプション</a></li>
								</ul>
							</td>
							<td class="btnLst">
									<ul>
										<li><button class="detailBtn" v-on:click="onDetail(list.nend,list.jgcd,list.kscd)">詳細</button></li>
										<li><button class="dltBtn" v-on:click="onDeleteSub(list.nend,list.jgcd,list.kscd)">削除</button></li>
									</ul>
							</td>
						</tr>
					</tbody>
				</table>        
				<!--データが一件もない場合に表示-->
				<div v-if="displayLists.length == 0">
					<p>データが一件も登録されていません。</p>
				</div>
			</section>
			<!-- △  END -->
		</section>
		<!-- △ mainContents END -->
		<!--モーダルWindow S -->
		<modalWindow v-show="modal.deleteRow.isShow" v-on:close="onDeleteRowModalClose">
			<dt slot="modal-header">確認</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.deleteRow.messages"></errorMessageBox>
				<button v-on:click="onDelete">削除</button>
				<button v-on:click="onDeleteRowModalClose">キャンセル</button>
			</dd>
			<dd slot="modal-footer"></dd>
		</modalWindow>
		<!--モーダルWindow E -->
		<!-- モーダルWindow S -->
		<modalWindow v-show="modal.systemError.isShow" v-on:close="onSystemErrorModalClose">
			<dt slot="modal-header">システムエラー</dt>
			<dd slot="modal-body">
				<errorMessageBox :errorMessages="modal.systemError.messages"></errorMessageBox>
			</dd>
			<dd slot="modal-footer"><a href="javascript:void(0)" v-on:click="onSystemErrorModalClose">閉じる</a></dd>
		</modalWindow>
		<!-- モーダルWindow E -->
	</div>
</template>
<script>
	import { WIRKSListApi } from '@/api'
	import * as types from '@/store/mutation-types'
	import * as ErrorCodes from '@/components/Utility/error-codes'
	import ErrorMessageBox from '@/components/Utility/ErrorMessageBox'
	import ModalWindow from '@/components/Utility/ModalWindow'
  import * as UtilityConsoleLog from '@/components/Utility/UtilityConsoleLog'

	export default {
		name: 'MasterWIRKSList',
		// 使用コンポーネント
		components: {
			// エラーメッセージ
			'errorMessageBox': ErrorMessageBox,
			// モーダルウィンドウ
			'modalWindow': ModalWindow
		},
		data() {
			return {
				// リスト表示用配列
				// nend: 年度
				// jgcd: クライアントコード
				// kscd: 健診コースコード
				// key:  キー
				// stdy: 予約登録開始日
				// eddy: 予約登録終了日
				// ksnm: 名称
				// upok: 公開フラグ
				// upokDisplay: 公開フラグの画面表示値
				displayLists: [],
				// 入力フォーム
				inputForm: {
					// 健康保険組合名の選択値（クライアントコード）
					jgcd: '',
					// 健康保険組合名　プルダウン内容
					// jgcd:クライアントコード
					// jgnm:クライアント名
					listJgyo: [],
				},
				// 削除レコード識別用年度
				deleteRecordNend: 0,
				// 削除レコード識別用クライアントコード
				deleteRecordJgcd: '',
				// 削除レコード識別用コースコード
				deleteRecordKscd: '',
				// モーダルウィンドウ
				modal: {
					deleteRow: {
						messages: [
							'削除しますか？'
						],
						isShow: false
					},
					systemError: {
						messages: [
							'システムエラーです。',
							'内容をもう一度ご確認ください。'
						],
						isShow: false
					}
				}
			}
		},
		// ライフサイクルハック　初期化
		created: function () {
			UtilityConsoleLog.consoleLog('MasterWIRKSList::created Start')

			this.firstDisplay()

			UtilityConsoleLog.consoleLog("MasterWIRKSList::created End")
		},
		methods: {
			// 初期表示
			firstDisplay: function() {
				UtilityConsoleLog.consoleLog("MasterWIRKSList::firstDisplay Start")

					// ストアに保存されたクライアントコードを取得する
					// ストアに値が保存されていない場合は「クライアントコード：個人（00000000）」を
					// 設定する
					var tempSearchJgcd = ''
					if(this.$store.state.adminUserChoice.MasterWIRKS.searchJgcd == '') {
						tempSearchJgcd = '00000000'
					} else {
						tempSearchJgcd = this.$store.state.adminUserChoice.MasterWIRKS.searchJgcd
					}

					// 非同期通信
					WIRKSListApi.FirstDisplay({ 
						token: this.$store.state.auth.token,
						ircd: this.$store.state.auth.ircd,
						jgcd: tempSearchJgcd
					}).then(({ responce }) => {

						if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

							//レスポンスの受け取り
							// クライアントプルダウン
							this.inputForm.listJgyo = responce.data.listJgyo
							// 最初の値を初期値にする
							this.inputForm.jgcd = this.inputForm.listJgyo[0].jgcd

							// コースリストを作成する
							var tempLists = responce.data.listIrks

							//初期化
							this.displayLists = []

							// リスト表示用配列の作成
							tempLists.forEach((list) => {

								// MLBRをMLBRDisplayにコード値変換
								var tempUpokDisplay = this.createUPOKDisplay(list.upok)

								this.displayLists.push({
									nend: list.nend,
									jgcd: list.jgcd,
									kscd: list.kscd,
									key:  list.key,
									stdy: list.stdy,
									eddy: list.eddy,
									ksnm: list.ksnm,
									upok: list.upok,
									upokDisplay: tempUpokDisplay
								})
							})

							// プルダウンで選択したのjgcdをstoreのsearchJgcd
							// （検索用クライアントコード）に登録
							this.$store.commit(
								types.ADMIN_USERCHOICE_WIRKS_SEARCH,
								{ searchJgcd: tempSearchJgcd })

							// クライアントコードをフォームに設定
							this.inputForm.jgcd = tempSearchJgcd

						} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
							|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
							// システム、DBエラー時
							this.onSystemErrorModalOpen()
						}

					}).catch(() => {
						this.onSystemErrorModalOpen()
					}).finally(() => {
						UtilityConsoleLog.consoleLog('MasterWIRKSList::firstDisplay End')
					})
			},
			// 検索ボタン押下時
			onSearch: function () {

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onSearch Start")

				// 非同期通信
				WIRKSListApi.Search({
					 token: this.$store.state.auth.token,
					 ircd: this.$store.state.auth.ircd,
					 jgcd: this.inputForm.jgcd 
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// コースリストを作成する
						var tempLists = responce.data.listIrks

						//初期化
						this.displayLists = []

						// リスト表示用配列の作成
						tempLists.forEach((list) => {

							// MLBRをMLBRDisplayにコード値変換
							var tempUpokDisplay = this.createUPOKDisplay(list.upok)

							this.displayLists.push({
								nend: list.nend,
								jgcd: list.jgcd,
								kscd: list.kscd,
								key: list.key,
								stdy: list.stdy,
								eddy: list.eddy,
								ksnm: list.ksnm,
								upok: list.upok,
								upokDisplay: tempUpokDisplay
							})
						})

						// プルダウンで選択したのjgcdをstoreのsearchJgcd
						// （検索用クライアントコード）に登録
						this.$store.commit(
							types.ADMIN_USERCHOICE_WIRKS_SEARCH,
							{ searchJgcd: this.inputForm.jgcd })

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIRKSList::onSearch End')
				})

			},
			// 新規作成ボタン
			onRegister: function () {
				UtilityConsoleLog.consoleLog("MasterWIRKSList::onRegister Start")

				//該当のjgcdをstoreに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIRKS_LISTTODETAIL,
					{ jgcd: this.inputForm.jgcd })

				this.$router.push("/MasterWIRKSRegister")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onRegister End")
			},
			// メニューへ戻る
			onBack: function () {
				UtilityConsoleLog.consoleLog("MasterWIRKSList::onBack Start")

				// ストアを初期化する
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIRKS_LISTTOHOME)

				this.$router.push("/AdminReserveStatusCheck")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onBack End")
			},
			// 年度更新
			onUpdateNend: function(){
				UtilityConsoleLog.consoleLog("MasterWIRKSList::onUpdateNend Start")

				//該当のjgcdをstoreに登録
				this.$store.commit(
				  types.ADMIN_USERCHOICE_WIRKS_BULK,
				  { jgcd: this.inputForm.jgcd })
				this.$router.push("/MasterWIRKSBulk")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onUpdateNend End")
			},
			// 詳細ボタン
			onDetail: function (in_nend, in_jgcd, in_kscd) {

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetail Start")

				//該当のnendとjgcdとkscdをstoreに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIRKS_LISTTODETAIL,
					{
						nend: in_nend, 
						jgcd: in_jgcd, 
						kscd: in_kscd
					})

				this.$router.push("/MasterWIRKSDetail")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetail End")
			},
			// コース毎　検査項目詳細ボタン
			onDetailWIRKM: function (in_nend, in_jgcd, in_kscd, in_key) {

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailWIRKM Start")

				//該当のnendとjgcdとkscdをstoreに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIRKS_LISTTOIRKM,
					{ 
						nend: in_nend,
						jgcd: in_jgcd,
						kscd: in_kscd,
						key: in_key
					})

				this.$router.push("/MasterWIRKM")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailWIRKM End")
			},
			// コース毎　予約枠詳細ボタン
			onDetailWKSWK: function (in_nend, in_jgcd, in_kscd, in_key) {

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailWKSWK Start")

				//該当のkeyをstoreに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIRKS_LISTTOKSWK,
					{
						nend: in_nend,
						jgcd: in_jgcd,
						kscd: in_kscd,
						key: in_key
					})

				this.$router.push("/MasterWKSWK")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailWKSWK End")
			},
			// コース毎 料金条件マスタボタン
			onDetailWRKKS: function (in_nend, in_jgcd, in_kscd, in_key) {

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailWRKKS Start")

				//該当のkeyに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIRKS_LISTTORKKS,
					{
						nend: in_nend,
						jgcd: in_jgcd,
						kscd: in_kscd,
						key: in_key
					})

				this.$router.push("/MasterWRKKS")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailWRKKS End")
			},
			// コース毎 オプションマスタボタン
			onDetailOPTION: function (in_nend, in_jgcd, in_kscd, in_key) {

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailOPTION Start")

				//該当のkeyに登録
				this.$store.commit(
					types.ADMIN_USERCHOICE_WIRKS_LISTTOOPTION,
					{
						nend: in_nend,
						jgcd: in_jgcd,
						kscd: in_kscd,
						key: in_key
					})

				this.$router.push("/MasterWRKOP")

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDetailOPTION End")
			},
			// UPOKのコード値変換
			createUPOKDisplay: function (upok) {
				UtilityConsoleLog.consoleLog("MasterWIRKSList::createMLBRDisplay Start")

				var tempUPOKDisplay = ''

				if (upok == '0') {
					tempUPOKDisplay = '非公開'
				} else if (upok == '1') {
					tempUPOKDisplay = '公開'
				}

				UtilityConsoleLog.consoleLog("MasterWIRKSList::createMLBRDisplay End")

				return tempUPOKDisplay
			},
			//削除ボタン
			onDeleteSub: function (in_nend, in_jgcd, in_kscd) {
				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDeleteSub Start")

				// 削除レコード識別用データを格納
				this.deleteRecordNend = in_nend
				this.deleteRecordJgcd = in_jgcd
				this.deleteRecordKscd = in_kscd

				//削除確認モーダルを開く
				this.onDeleteRowModalOpen()

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDeleteSub End")

			},
			//削除確認モーダルでの削除ボタン
			onDelete: function () {

				UtilityConsoleLog.consoleLog("MasterWIRKSList::onDelete Start")

				WIRKSListApi.ListDelete({
					token: this.$store.state.auth.token,
					nend: this.deleteRecordNend,
					ircd: this.$store.state.auth.ircd,
					jgcd: this.deleteRecordJgcd,
					kscd: this.deleteRecordKscd
				}).then(({ responce }) => {

					if (responce.data.errorCode == ErrorCodes.ERRORCODE_DEFAULT) {

						// コースリストを作成する
						var tempLists = responce.data.listIrks

						//初期化
						this.displayLists = []

						// リスト表示用配列の作成
						tempLists.forEach((list) => {

							// MLBRをMLBRDisplayにコード値変換
							var tempUPOKDisplay = this.createUPOKDisplay(list.upok)

							this.displayLists.push({
								nend: list.nend,
								jgcd: list.jgcd,
								kscd: list.kscd,
								key: list.key,
								stdy: list.stdy,
								eddy: list.eddy,
								ksnm: list.ksnm,
								upok: list.upok,
								upokDisplay: tempUPOKDisplay
							})
						})

						//モーダルウィンドウを閉じる
						this.modalClose('deleteRow')

					} else if (responce.data.errorCode == ErrorCodes.ERRORCODE_SIMPLEITEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_SYSTEM
						|| responce.data.errorCode == ErrorCodes.ERRORCODE_DB) {
						// システム、DBエラー時
						this.onSystemErrorModalOpen()
					}
				}).catch(() => {
					// システムエラー時
					this.onSystemErrorModalOpen()
				}).finally(() => {
					UtilityConsoleLog.consoleLog('MasterWIRKSList::onDelete End')
				})
			},
			// 削除確認モーダルとしてモーダルウィンドウを開く
			onDeleteRowModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSList::onDeleteRowModalOpen Start')

				this.modalOpen('deleteRow')

				UtilityConsoleLog.consoleLog('MasterWIRKSList::onDeleteRowModalOpen End')
			},
			// 削除確認モーダルとしてモーダルウィンドウを閉じる
			onDeleteRowModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSList::onDeleteRowModalClose Start')

				// 削除レコード識別用データを格納
				this.deleteRecordNend = 0
				this.deleteRecordJgcd = ''
				this.deleteRecordKscd = ''

				this.modalClose('deleteRow')

				UtilityConsoleLog.consoleLog('MasterWIRKSList::onDeleteRowModalClose End')
			},
			// システムエラーモーダルとしてエラーモーダルを開く
			onSystemErrorModalOpen: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSList::onSystemErrorModalOpen Start')

				this.modalOpen('systemError')

				UtilityConsoleLog.consoleLog('MasterWIRKSList::onSystemErrorModalOpen End')
			},
			// システムエラーモーダルウィンドウの閉じるボタン
			onSystemErrorModalClose: function () {
				UtilityConsoleLog.consoleLog('MasterWIRKSList::onSystemErrorModalClose Start')

				this.modalClose('systemError')
				this.$router.push('/AdminLogin')

				UtilityConsoleLog.consoleLog('MasterWIRKSList::onSystemErrorModalClose End')
			},
			// モーダルウィンドウを開く
			modalOpen: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWIRKSList::modalOpen Start')

				// すべてのモーダルを閉じる
				this.allModalClose()

				this.modal[modalName].isShow = true

				UtilityConsoleLog.consoleLog('MasterWIRKSList::modalOpen End')
			},
			// モーダルウィンドウを閉じる
			modalClose: function (modalName) {
				UtilityConsoleLog.consoleLog('MasterWIRKSList::modalClose Start')

				this.modal[modalName].isShow = false

				UtilityConsoleLog.consoleLog('MasterWIRKSList::modalClose End')
			},
			// 全てのモーダルを閉じる
			allModalClose: function() {  
				for(var key in this.modal) {
					this.modal[key].isShow = false
				}
			}
		}
	}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Master/WIRKS/MasterWIRKSList.vue